import type { Dictionary } from './en.ts';

export const de: Dictionary = {
  'app.title': 'Online-Terminbuchung',
  'app.offline': 'Du bist offline. Gespeicherte Daten werden angezeigt.',
  'app.update': 'Eine neue Version ist verfügbar.',
  'app.reload': 'Neu laden',
  'nav.book': 'Buchen',
  'nav.my': 'Meine Termine',
  'nav.language': 'Sprache',
  'footer.imprint': 'Impressum',
  'footer.privacy': 'Datenschutz',

  'home.title': 'Barbershops',
  'home.subtitle': 'Wähle einen Salon, um einen Termin zu buchen.',
  'home.empty': 'Noch keine Salons eingerichtet.',

  'book.service': 'Leistung',
  'book.barber': 'Barber',
  'book.anyBarber': 'Egal wer',
  'book.anyBarberHint': 'Frühester freier Termin',
  'book.date': 'Datum',
  'book.time': 'Uhrzeit',
  'book.noSlots': 'An diesem Tag ist nichts mehr frei. Bitte wähle einen anderen Tag.',
  'book.closed': 'Geschlossen',
  'book.yourDetails': 'Deine Angaben',
  'book.name': 'Name',
  'book.phone': 'Telefon',
  'book.email': 'E-Mail (optional, für Bestätigung und Erinnerung)',
  'book.consent': 'Wir verwenden deine Daten nur für diesen Termin.',
  'book.privacyLink': 'Datenschutzhinweise',
  'book.remember': 'Angaben auf diesem Gerät merken',
  'book.confirm': 'Jetzt buchen',
  'book.booking': 'Wird gebucht…',
  'book.summary': '{service} bei {barber}',
  'book.successTitle': 'Gebucht!',
  'book.successText': 'Bis {date}.',
  'book.addCalendar': 'Zum Kalender hinzufügen',
  'book.another': 'Weiteren Termin buchen',
  'book.cancelHint': 'Kostenlose Stornierung bis {hours} Std. vor dem Termin.',

  'my.title': 'Meine Termine',
  'my.empty': 'Auf diesem Gerät gibt es noch keine Buchungen.',
  'my.upcoming': 'Anstehend',
  'my.past': 'Vergangen',
  'my.cancel': 'Stornieren',
  'my.cancelConfirm': 'Diesen Termin wirklich stornieren?',
  'my.cancelled': 'Termin storniert.',
  'my.tooLate': 'Stornierung nur bis {hours} Std. vorher möglich. Bitte ruf uns an.',

  'status.pending': 'Offen',
  'status.confirmed': 'Bestätigt',
  'status.completed': 'Erledigt',
  'status.cancelled': 'Storniert',
  'status.no_show': 'Nicht erschienen',

  'error.generic': 'Etwas ist schiefgelaufen. Bitte versuch es noch einmal.',
  'error.network': 'Keine Verbindung. Bitte prüfe dein Internet.',
  'error.notFound': 'Seite nicht gefunden.',
  'error.tenantNotFound': 'Diesen Salon gibt es nicht.',
  'error.slotTaken': 'Dieser Termin wurde gerade vergeben. Bitte wähle einen anderen.',
  'error.rateLimited': 'Zu viele Buchungen in kurzer Zeit. Bitte versuch es später noch einmal.',
  'error.outsideWindow': 'Dieser Termin ist nicht mehr buchbar.',
  'error.invalid': 'Die Eingaben konnten nicht gespeichert werden. Bitte prüfe sie.',
  'error.unauthorized': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  'error.invalidLogin': 'E-Mail oder Passwort ist falsch.',
  'error.name_short': 'Bitte gib deinen Namen ein.',
  'error.name_long': 'Der Name ist zu lang.',
  'error.phone_invalid': 'Bitte gib eine gültige Telefonnummer ein, z. B. 0151 2345678.',
  'error.email_invalid': 'Bitte gib eine gültige E-Mail-Adresse ein.',
  'error.back': 'Zur Startseite',

  'hero.kicker': 'Barbershop · {city}',
  'hero.book': 'Termin buchen',
  'hero.call': 'Anrufen',
  'hero.openNow': 'Jetzt geöffnet · bis {time} Uhr',
  'hero.opensToday': 'Geschlossen · öffnet heute um {time} Uhr',
  'hero.opensTomorrow': 'Geschlossen · öffnet morgen um {time} Uhr',
  'hero.opensOn': 'Geschlossen · öffnet {day} um {time} Uhr',
  'info.address': 'Adresse',
  'info.route': 'Route planen',
  'info.hours': 'Öffnungszeiten',
  'info.contact': 'Kontakt',
  'info.today': 'Heute',
  'step.service': 'Wähle deine Leistung',
  'step.barber': 'Wer soll schneiden?',
  'step.date': 'Welcher Tag?',
  'step.time': 'Welche Uhrzeit?',
  'step.details': 'Deine Angaben',
  'slots.morning': 'Vormittag',
  'slots.afternoon': 'Nachmittag',
  'slots.evening': 'Abend',
  'book.ticket': 'Dein Termin',
  'home.heroTitle': 'Dein Barber. Online gebucht.',
  'home.heroText': 'Salon, Leistung und Uhrzeit wählen – in unter einer Minute erledigt.',
  'home.book': 'Buchen',
};
